import React from 'react';
import Text from '@amzn/meridian/text';
import Box from '@amzn/meridian/box';
import { Contact } from '../../../api/ContactListening/schema';
import Divider from '@amzn/meridian/divider';
import Column from '@amzn/meridian/column';
import { FormattedMessage } from 'react-intl';
import Row from '@amzn/meridian/row';
import { processHtml } from '../utils/Text';
import _ from 'lodash';
import CoachingEmptyState from '../../../Assets/coachingEmptyState.png';
export interface EmailMediumProps {
  contact: Contact | undefined;
}

export const EmailMedium: React.FC<EmailMediumProps> = ({ contact }) => {
  const emailSubjectRedacted = _.get(contact, 'medium.emailSubjectRedacted');
  const emailBodyRedacted = _.get(contact, 'medium.emailBodyRedacted');

  if (!emailSubjectRedacted && !emailBodyRedacted) {
    return (
      <Column alignmentHorizontal='center' alignmentVertical='center'>
        <div>
          <img src={CoachingEmptyState} alt='no contacts' />
        </div>
        <Text>
          <FormattedMessage
            id='cs_perfportal_contact_listening_no_email_transcript'
            defaultMessage='There is no email transcript to display here at the moment.'
          />
        </Text>
      </Column>
    );
  }

  const emailDisplay = (emailSubjectRedacted: any, emailBodyRedacted: any) => {
    return (
      <Column width='100%' spacing='100'>
        <Row width='90%'>
          <Box spacingInset='200'>
            <Row spacingInset='none none 300 none'>
              <Text type='h100' color={'primary'}>
                <FormattedMessage
                  id='cs_perfportal_contact_listening_email_subject'
                  defaultMessage='Subject'
                />
              </Text>
            </Row>
            {emailSubjectRedacted && (
              <Text type='b300' color={'primary'}>
                {emailSubjectRedacted}
              </Text>
            )}
            <Divider spacingBefore='300' spacingAfter='300' />
            <Row spacingInset='300 none'>
              <Text type='h100' color={'primary'}>
                <FormattedMessage
                  id='cs_perfportal_contact_listening_email_body'
                  defaultMessage='Email body'
                />
              </Text>
            </Row>
            {emailBodyRedacted && (
              <Row>
                <div
                  style={{
                    whiteSpace: 'pre-line',
                    overflowWrap: 'break-word',
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: processHtml(emailBodyRedacted),
                  }}
                />
              </Row>
            )}
          </Box>
        </Row>
      </Column>
    );
  };

  return (
    <Box overflowY='scroll' maxHeight='600px' width='fill' spacingInset='200'>
      {emailDisplay(emailSubjectRedacted, emailBodyRedacted)}
    </Box>
  );
};
export default EmailMedium;
